export default "__VITE_ASSET__04a2af42__"